import { apiCall } from "./apiClient";

export interface TachogramMediaMeta {
    type: string;
    command_id?: number;
    slot?: string;
    driver_name?: string;
    card_number?: string;
    vehicle_registration?: string;
    vin?: string;
}

export interface TachogramMediaItem {
    uuid: string;
    url: string;
    name: string;
    size: number;
    mime: string;
    created: number;
    uploaded: number;
    meta: TachogramMediaMeta;
}

export interface DriverTachogramDownloadResult {
    employeeId: string;
    employeeName: string;
    tachoCardId: string | null;
    hasDriverCard: boolean;
    statusMessage: string | null;
    files: TachogramMediaItem[];
}

export interface VehicleTachogramDownloadResult {
    vehicleId: string;
    registerNumber: string;
    integrationUniqueId: string;
    files: TachogramMediaItem[];
}

export const getDriverTachogramDownloads = async(
    signal?: AbortSignal
): Promise<DriverTachogramDownloadResult[]> => {
    const response = await apiCall<DriverTachogramDownloadResult[]>(
        "tachogramdownloads/drivers",
        "GET",
        undefined,
        signal
    );
    return response.data;
};

export const getVehicleTachogramDownloads = async(
    signal?: AbortSignal
): Promise<VehicleTachogramDownloadResult[]> => {
    const response = await apiCall<VehicleTachogramDownloadResult[]>(
        "tachogramdownloads/vehicles",
        "GET",
        undefined,
        signal
    );
    return response.data;
};
